import { render } from "./CIconSelector.vue?vue&type=template&id=c274671c"
import script from "./CIconSelector.vue?vue&type=script&lang=js"
export * from "./CIconSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__